import React from 'react';
import Container from 'react-bootstrap/Container';
// import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import {Link} from 'react-router-dom';
// import {resourceEndpoint} from './config';
// import {useTranslation} from 'react-i18next'



function Home(props) {  
  const displayBody = () => {
    console.log("home props", props)
    return (
      <div className="Home" style={{width: "50%", "margin": "auto", "marginTop": "calc(10% + 50px)"}}>
        <Container id="lbp-home" fluid>
            <Container>
              <div id="lbp-jumbo">
              	<h1>{props.title}</h1>
                <h2>{props.subtitle}</h2>
                <p>
                {props.text}
                </p>
                <Button variant="primary" size="lg" className="mb-3">
                  <Link to={"/text?resourceid=" + props.entryResource} style={{color: "black", textDecoration: "none"}}>Start Reading</Link>
                </Button>
              </div>
            </Container>
          </Container>
          </div>
    )
  }
  return (
    displayBody()
  )
}

export default Home;
